export default "__VITE_ASSET__DLjYYHus__"